import { Text, View } from 'react-native'
import { styled } from '~/core/styled'

export const BadgeContainer = styled(View, theme => {
  return {
    base: {
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: theme.paddingInsetOnepulse,
      borderRadius: theme.borderRadiusPill,
      backgroundColor: theme.colorTextNeutralDefault,
      color: theme.colorTextNeutralInverse,
    },
    variants: {
      size: {
        md: {
          height: theme.sizingExtrasmall,
          width: theme.sizingExtrasmall,
        },
        ml: {
          height: theme.sizingSmall,
          width: theme.sizingSmall,
        },
      },
      disabled: {
        true: {
          backgroundColor: theme.colorTextNeutralDisabled,
          color: theme.colorTextNeutralInverse,
        },
      },
      readOnly: {
        true: {
          backgroundColor: theme.colorTextNeutralReadonly,
          color: theme.colorTextNeutralInverse,
        },
      },
    },
  }
})

export const BadgeText = styled(Text, theme => {
  return {
    base: {
      fontSize: theme.fontSizeThreepulse,
      fontFamily: theme.fontFamily.regular,
      color: theme.colorTextNeutralInverse,
    },
  }
})
